import { render, staticRenderFns } from "./change-user.vue?vue&type=template&id=bf90e86a"
import script from "./change-user.vue?vue&type=script&lang=ts"
export * from "./change-user.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports